export enum WebsocketConnectionKeys {
    USERS = 'USERS',
    LISTINGS = 'LISTINGS',
    DISTRIBUTION_TRACKING = 'DISTRIBUTION_TRACKING',
    CONTENT_SCORE = 'CONTENT_SCORE',
    LISTING_SNAPSHOTS = 'LISTING_SNAPSHOTS',
    LISTING_VALIDATION = 'LISTING_VALIDATION',
}
